import ModalToOpenService from "@core-ui/ContextServices/ModalToOpenService/ModalToOpenService";
import t from "@ext/localization/locale/translate";
import {
	AlertDialog,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogIcon,
	AlertDialogTitle,
} from "@ui-kit/AlertDialog";

const OtherStorageHandler = () => {
	const close = () => ModalToOpenService.resetValue();

	return (
		<AlertDialog open>
			<AlertDialogContent status="warning">
				<AlertDialogHeader>
					<AlertDialogIcon icon="alert-circle" />
					<AlertDialogTitle>{t("git.clone.other-storage.title")}</AlertDialogTitle>
					<AlertDialogDescription asChild>
						<div className="article !bg-transparent">
							<div className="article-body">
								<p>{t("git.clone.other-storage.body")}</p>
							</div>
						</div>
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel onClick={close} variant="outline">
						{t("close")}
					</AlertDialogCancel>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};

export default OtherStorageHandler;
